import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { ReturnDetails } from "../../returns.types";
import { getProducts } from "./getProducts";

interface renderProductsProps {
  pdf: jsPDF;
  returnDetails: ReturnDetails;
  normalFontStyles: Partial<Styles>;
}

export const renderProducts = ({
  pdf,
  returnDetails,
  normalFontStyles
}: renderProductsProps) => {
  const { products } = getProducts({ returnDetails, normalFontStyles });

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: t("ITEMS RETURNING"),
          styles: {
            valign: "middle",
            halign: "left",
            ...normalFontStyles
          }
        }
      ]
    ],
    body: products,
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
